// extracted by mini-css-extract-plugin
export default {"container":"CreateIssueForm_container__McwZ2","group":"CreateIssueForm_group__FMJfK"};